import React from 'react';
import produce from 'immer';
import { useField } from '@rocketseat/unform';

import {
  Text,
  Modal,
  Button,
  Dropdown,
  TextField,
  TelefoneBox,
} from '@unimed-fesp/components';

import {
  ContentWrapper,
  FooterWrapper,
  BodyWrapper,
  UsuarioWrapper,
  ContatoWrapper,
} from './styles';
import theme from '../../styles/theme';

// #region Componentes
import ModalCancelActionFooter from './ModalCancelActionFooter';
// #endregion

const DadosGerais = ({
  perfilNovoUsuario,
  openModalCancelAction,
  handleCancelarCadastro,
  handleModalCancelAction,
  setUsuarioParams,
  usuarioParams,
  display,
  handleAvancarTab,
  contatoParams,
  setContatoParams,
  isButtonDisabled,
}) => {
  const optionsPermissao = [
    {
      onClickOption: () => handleSelected('Consulta', 'tipoPermissaoUsuario'),
      text: 'Consulta',
    },
    {
      onClickOption: () => handleSelected('Alteração', 'tipoPermissaoUsuario'),
      text: 'Alteração',
    },
  ];

  const registerNome = useField('nome').registerField;
  const registerMatricula = useField('matricula').registerField;
  const registerPerfilUsuario = useField('tipoPerfilUsuario').registerField;
  const registerPermissao = useField('tipoPermissaoUsuario').registerField;

  function handleSelected(text, status) {
    const newEditarUsuarioParams = produce(usuarioParams, (draft) => {
      if (draft[status] !== text) draft[status] = text;

      return draft;
    });

    setUsuarioParams(newEditarUsuarioParams);
  }

  function handleChange(e, status) {
    const newEditarUsuarioParams = produce(usuarioParams, (draft) => {
      if (draft[status] !== e.target.value) draft[status] = e.target.value;

      return draft;
    });

    setUsuarioParams(newEditarUsuarioParams);
  }

  return (
    <ContentWrapper display={display}>
      <BodyWrapper height={perfilNovoUsuario === 'Contratante' ? '800px' : ''}>
        <UsuarioWrapper>
          <Text
            font="bold 16px/14px Calibri"
            color={theme.greenDefault}
            text="Usuário"
            paddingBottom="20"
          />
          <TextField
            name="nome"
            labelText="Nome"
            width={623}
            marginBottom={30}
            marginTop={5}
            placeholder="Informe o nome completo do usuário"
            value={usuarioParams.nome}
            font="13px 'Calibri Regular'"
            onChange={(e) => handleChange(e, 'nome')}
            register={registerNome}
          />
          {perfilNovoUsuario === 'Contratante' && (
            <TextField
              name="matricula"
              labelText="Matrícula (Opcional)"
              width={322}
              marginBottom={30}
              marginTop={0}
              placeholder="Informe o número da matrícula"
              value={usuarioParams.matricula}
              font="13px 'Calibri Regular'"
              onChange={(e) => handleChange(e, 'matricula')}
              register={registerMatricula}
            />
          )}
          <Dropdown
            tipo="dropdown"
            width={220}
            labelText="Perfil"
            name="tipoPerfilUsuario"
            marginTop={9}
            marginBottom={30}
            height={46}
            disable
            register={registerPerfilUsuario}
          >
            {perfilNovoUsuario}
          </Dropdown>
          {perfilNovoUsuario === 'Contratante' && (
            <Dropdown
              options={optionsPermissao}
              tipo="dropdown"
              width={220}
              labelText="Permissão"
              name="tipoPermissaoUsuario"
              marginTop={9}
              marginBottom={30}
              height={46}
              display={perfilNovoUsuario === 'Contratante' ? 'table' : 'none'}
              register={registerPermissao}
            >
              {usuarioParams.tipoPermissaoUsuario || 'Selecione a permissão'}
            </Dropdown>
          )}
        </UsuarioWrapper>
        <ContatoWrapper>
          <Text
            font="bold 16px/14px Calibri"
            color={theme.greenDefault}
            text="Contato"
            paddingBottom="20"
          />
          <TelefoneBox
            contatos={contatoParams.contatos}
            callbackChangeContatos={(contatos) =>
              setContatoParams({ contatos })
            }
            useField={useField}
          />
        </ContatoWrapper>
      </BodyWrapper>
      <FooterWrapper>
        <Button
          tipo="tertiary"
          justifyCenter
          alignCenter
          type="button"
          width={100}
          font="16px unimed_slabregular"
          onClick={handleModalCancelAction}
        >
          cancelar
        </Button>
        <Button
          tipo="primary"
          justifyCenter
          disabled={isButtonDisabled}
          type="button"
          width={100}
          font="16px unimed_slabregular"
          onClick={handleAvancarTab}
        >
          avançar
        </Button>
      </FooterWrapper>
      <Modal
        tipo="warning"
        onClick={handleModalCancelAction}
        isOpen={openModalCancelAction}
        footer={
          <ModalCancelActionFooter
            onClick={handleModalCancelAction}
            onClickOk={handleCancelarCadastro}
          />
        }
      >
        <Text
          center
          text="Ao cancelar o cadastro do usuário, você perderá os dados não salvos. Deseja continuar?"
          font="300 14px work_sans"
          color={theme.titleGray}
        />
      </Modal>
    </ContentWrapper>
  );
};

export default DadosGerais;
